import React from 'react';
import { THEMES, DEFAULT_THEME } from './themes';
import UniversalTemplate from './UniversalTemplate';

import BodaClasica from './BodaClasica';
import BodaElegante from './BodaElegante';
import BodaBoho from './BodaBoho';
import CumpleInfantil from './CumpleInfantil';
import BabyShowerAzul from './BabyShowerAzul';
import BautizoDorado from './BautizoDorado';
import GraduacionModerna from './GraduacionModerna';

export default function TemplateRenderer({ template, data, title, media = [], audio = null, cover = null }) {
  if (!template) return null;
  const slug = template.slug;

  if (slug === 'boda-clasica')
    return <BodaClasica data={data} title={title} media={media} audio={audio} cover={cover} />;
  if (slug === 'boda-elegante')
    return <BodaElegante data={data} title={title} media={media} audio={audio} cover={cover} />;
  if (slug === 'boda-boho')
    return <BodaBoho data={data} title={title} media={media} audio={audio} cover={cover} />;
  if (slug === 'cumple-infantil')
    return <CumpleInfantil data={data} title={title} media={media} audio={audio} cover={cover} />;
  if (slug === 'baby-shower-azul')
    return <BabyShowerAzul data={data} title={title} media={media} audio={audio} cover={cover} />;
  if (slug === 'bautizo-dorado')
    return <BautizoDorado data={data} title={title} media={media} audio={audio} cover={cover} />;
  if (slug === 'graduacion-moderna')
    return <GraduacionModerna data={data} title={title} media={media} audio={audio} cover={cover} />;

  const theme = THEMES[slug] || DEFAULT_THEME;
  return (
    <UniversalTemplate
      template={template}
      data={data}
      title={title}
      theme={theme}
      media={media}
      audio={audio}
      cover={cover}
    />
  );
}